import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BrowserModule } from '@angular/platform-browser';
import { AppModuleChord } from '../chord/module';

import { AppViewChord } from './Chord';
import { AppViewChords } from './Chords';
import { AppViewChordsteps } from './Chordsteps';
import { AppViewError } from './Error';
import { AppViewIndex } from './Index';
import { AppViewSong } from './Song';
import { RouterModule } from '@angular/router';
import { AppViewSongs } from './Songs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppViewChord,
    AppViewChords,
    AppViewChordsteps,
    AppViewError,
    AppViewIndex,
    AppViewSong,
    AppViewSongs,
  ],
  exports: [
    AppViewChord,
    AppViewChords,
    AppViewChordsteps,
    AppViewError,
    AppViewIndex,
    AppViewSong,
    AppViewSongs,
  ],
  imports: [
    BrowserModule,
    AppModuleChord,
    FontAwesomeModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
  ]
})
export class AppModuleView { }
